<template>
  <div :class="['book-page page-wrap', { 'book-page--map': step === 2 }]">
    <div :class="['book-shell', { 'book-shell--map': step === 2 }]">
      <div class="book-topbar">
        <button type="button" class="icon-btn" @click="goBack">←</button>
        <div class="book-topbar__title" v-if="currentClub">
          {{ step === 1 ? currentClub.name : 'Выберите место' }}
        </div>
        <button type="button" class="icon-btn" @click="$router.push('/clubs')">i</button>
      </div>

      <!--<div v-if="currentClub" class="club-card">
        <div class="club-card__thumb">
          <img v-if="clubImageUrl" :src="clubImageUrl" alt="" />
          <div v-else class="club-card__thumb-placeholder"></div>
        </div>

        <div class="club-card__body">
          <div class="club-card__name">{{ currentClub.name }}</div>
          <div class="club-card__address">{{ currentClub.address || 'Адрес клуба не указан' }}</div>
        </div>

        <div class="club-card__rate">5.0 ★</div>
      </div>-->

      <div v-if="initLoading" class="state-card">
        Загружаем бронь...
      </div>

      <div v-else-if="pageError" class="state-card state-card--error">
        {{ pageError }}
      </div>

      <template v-else>
        <div v-if="step === 1" class="section-card switch-section__card">
          <div class="mode-switch">
            <button
              type="button"
              :class="{ active: bookingMode === 'hourly' }"
              @click="changeMode('hourly')"
            >
              Поминутный
            </button>
            <button
              type="button"
              :class="{ active: bookingMode === 'package' }"
              @click="changeMode('package')"
            >
              Пакеты
            </button>
          </div>
        </div>

        <div v-if="step === 1 && bookingMode === 'package'" class="section-card packet__chooser">
          <!--<div class="section__head section__head--compact">
            <span>Пакет</span>
          </div>-->

          <div ref="tariffsSlider" class="tariffs-slider" v-if="packageTariffs.length">
            <button
              v-for="tariff in visiblePackageTariffs"
              :key="tariff.key"
              type="button"
              class="tariff-pill"
              :class="getTariffPillClasses(tariff)"
              :style="getTariffPillStyle(tariff)"
              @click="selectTariff(tariff.key)"
            >
              <template v-if="hasTariffFire(tariff)">
                <span
                  class="tariff-pill__glow"
                  :class="`tariff-pill__glow--${getTariffFireVariant(tariff)}`"
                ></span>
                <template v-if="getTariffFireVariant(tariff) === 'lightning'">
                  <canvas class="tariff-pill__lightning" data-lightning-root="1"></canvas>
                </template>
                <template v-else>
                  <span
                    class="tariff-pill__fire"
                    :class="`tariff-pill__fire--${getTariffFireVariant(tariff)}`"
                    data-fire-root="1"
                    :data-fire-variant="getTariffFireVariant(tariff)"
                  ></span>
                </template>
                <span
                  class="tariff-pill__face"
                  :class="`tariff-pill__face--${getTariffFireVariant(tariff)}`"
                ></span>
              </template>

              <div class="tariff-pill__title">{{ tariff.name }}</div>
              <div class="tariff-pill__meta">
                {{ tariff.description }}
              </div>
            </button>
          </div>

          <div v-if="!packageTariffs.length" class="minute-note">
            Доступных пакетов нет
          </div>

          <div v-else-if="!visiblePackageTariffs.length" class="minute-note">
            Доступных пакетов нет
          </div>
        </div>

        <div v-if="step === 1" class="step step--time">
          

          

          <div class="section-card section-card--wheel">
            <div class="section-card__date">
              <!--<div class="section__head">
                <span>Дата</span>
                <strong>{{ dateContextLabel }}</strong>
              </div>-->

              <div class="date-rail">
                <button
                  v-for="item in dateRailOptions"
                  :key="item.value"
                  type="button"
                  class="date-chip"
                  :class="{ active: selectedDate === item.value }"
                  @click="selectDate(item.value)"
                >
                  <span class="date-chip__weekday">{{ item.weekday }}</span>
                  <strong class="date-chip__day">{{ item.day }}</strong>
                </button>

                <button
                  type="button"
                  class="date-chip date-chip--calendar"
                  :class="{ active: calendarOpen }"
                  @click="openCalendar"
                >
                  <span class="date-chip__calendar">🗓</span>
                </button>
              </div>
            </div>

            <div class="wheel-subtitle">
              <template v-if="bookingMode === 'hourly'">
                Выберите время
              </template>
              <template v-else>
                Выберите время начала пакета
              </template>
            </div>

            <div
              class="wheel-grid"
              :class="{ 'wheel-grid--single': bookingMode === 'package' }"
            >
              <div class="wheel-grid__baraban">
                <div class="wheel-label">
                  {{ bookingMode === 'package' ? 'От' : 'От' }}
                </div>

                <TimeWheel
                  v-model="startValue"
                  :items="startWheelItems"
                  :row-height="wheelRowHeight"
                  :wheel-threshold="240"
                  :wheel-cooldown="150"
                />
              </div>

              <div v-if="bookingMode === 'hourly'" class="wheel-grid__baraban">
                <div class="wheel-label">До</div>

                <TimeWheel
                  v-model="endValue"
                  :items="endWheelItems"
                  :row-height="wheelRowHeight"
                  :wheel-threshold="240"
                  :wheel-cooldown="150"
                />
              </div>
            </div>

           

            <!--<div class="range-card">
              <div class="range-card__col">
                <div class="range-card__label">Начало</div>
                <div class="range-card__date">{{ startCardDateLabel }}</div>
                <div class="range-card__time">{{ selectedStartTimeLabel }}</div>
              </div>

              <div class="range-card__sep">до</div>

              <div class="range-card__col">
                <div class="range-card__label">Конец</div>
                <div class="range-card__date">{{ endCardDateLabel }}</div>
                <div class="range-card__time">{{ selectedEndTimeLabel }}</div>
              </div>
            </div>-->

            <!--<div class="minute-note" v-if="bookingMode === 'hourly' && minuteTariff">
              {{ minuteTariff.name || 'Поминутный тариф' }} · ~{{ money(minuteRatePerMinute) }}/мин
            </div>-->
          </div>

          <button
            type="button"
            class="main-btn"
            :disabled="!canGoStep2 || availabilityLoading"
            @click="goStep2"
          >
            {{ availabilityLoading ? 'Проверяем места...' : 'Выбрать место' }}
          </button>

          <p v-if="submitError" class="error-text">{{ submitError }}</p>
        </div>

        <div v-else ref="mapStep" class="step step--map">
          <div ref="mapWrap" class="map-wrap">
            <SeatMap
              :layout="layout"
              :seats="seats"
              :busy-seat-ids="busySeatIds"
              :selected-seat-ids="selectedSeatIds"
              :allowed-seat-types="allowedSeatTypesForPackage"
              @select="selectSeat"
            />
          </div>

          <div ref="rangeCardMap" class="range-card range-card--map">
            <div class="range-card__col">
              <div class="range-card__label">Начало</div>
              <div class="range-card__date">{{ startCardDateLabel }}</div>
              <div class="range-card__time">{{ selectedStartTimeLabel }}</div>
            </div>

            <div class="range-card__sep">до</div>

            <div class="range-card__col">
              <div class="range-card__label">Конец</div>
              <div class="range-card__date">{{ endCardDateLabel }}</div>
              <div class="range-card__time">{{ confirmedEndTimeLabel }}</div>
            </div>
          </div>

          <div ref="selectionInline" class="selection-inline">
            <div class="selection-inline__top">
              <strong>Выбрано: {{ selectedSeatsLabel }}</strong>
              <strong>{{ totalPriceLabel }}</strong>
            </div>
          </div>

          <div ref="actionsSingle" class="actions actions--single">
            <button
              type="button"
              class="main-btn"
              :disabled="!canSubmit || submitting"
              @click="submitBooking"
            >
              {{ submitting ? 'Создаем бронь...' : 'Подтвердить' }}
            </button>
          </div>

          <p v-if="submitError" class="error-text">{{ submitError }}</p>
        </div>
      </template>
    </div>

    <div v-if="calendarOpen" class="calendar-modal" @click.self="closeCalendar">
      <div class="calendar-card">
        <div class="calendar-card__head">
          <button type="button" class="calendar-nav" :disabled="!calendarCanGoPrev" @click="goPrevMonth">←</button>
          <div class="calendar-card__title">{{ calendarMonthTitle }}</div>
          <button type="button" class="calendar-nav" :disabled="!calendarCanGoNext" @click="goNextMonth">→</button>
        </div>

        <div class="calendar-weekdays">
          <span v-for="item in weekdayHeaders" :key="item">{{ item }}</span>
        </div>

        <div class="calendar-grid">
          <button
            v-for="day in calendarDays"
            :key="day.key"
            type="button"
            class="calendar-day"
            :class="{
              outside: day.outside,
              selected: day.selected,
              today: day.today,
            }"
            :disabled="day.disabled"
            @click="selectCalendarDay(day.value)"
          >
            {{ day.label }}
          </button>
        </div>

        <div class="calendar-card__foot">
          <button type="button" class="ghost-btn ghost-btn--small" @click="closeCalendar">Закрыть</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SeatMap from '../components/booking/SeatMap.vue';
import TimeWheel from '../components/booking/TimeWheel.vue';
import {
  MIN_BOOKING_LEAD_MINUTES,
  addDays,
  addMonths,
  buildDateTimeValue,
  buildDateTimeValueByOffset,
  diffBetweenDateTimeValues,
  formatLongDate,
  formatMonthTitle,
  getDatePart,
  getTimePart,
  isoDate,
  minutesToTime,
  pad,
  parseIso,
  relativeDayLabel,
  roundUpToStep,
  sameMonth,
  startOfDay,
  startOfMonth,
  timeToMinutes,
} from '../utils/bookingDateTime';
import { DEFAULT_TIME_ZONE, getZonedDate, normalizeTimeZone } from '../utils/timezone';
import { buildPackageTariffs, isTariffVisibleForDateTime, calculatePackageTotal, calculatePackagePriceForSeat, getPackageDurationMins, normalizeSeatType as normalizeBookingSeatType } from '../utils/bookingTariffs';

export default {
  name: 'BookView',
  components: {
    SeatMap,
    TimeWheel,
  },
  data() {
    const today = startOfDay(new Date());
    const maxDate = addDays(today, 13);

    return {
      step: 1,
      bookingMode: 'hourly',
      selectedTariffId: null,
      startValue: '',
      endValue: '',
      selectedSeatIds: [],
      selectedDate: isoDate(today),
      minBookingDate: isoDate(today),
      maxBookingDate: isoDate(maxDate),
      calendarOpen: false,
      calendarCursor: startOfMonth(today),
      windowWidth: typeof window !== 'undefined' ? window.innerWidth : 1280,
      mapViewportMinHeight: 0,
      localPageError: '',
      bootstrapping: false,
      bootstrappedClubId: 0,
    };
  },
  computed: {
    wheelRowHeight() {
      if (this.windowWidth <= 560) return 56;
      if (this.windowWidth <= 760) return 62;
      return 72;
    },
    user() {
      return this.$store.getters['auth/user'];
    },
    clubs() {
      return this.$store.getters['clubs/items'] || [];
    },
    currentClub() {
      return this.$store.getters['clubs/currentClub'];
    },
    currentClubTimezone() {
      return normalizeTimeZone(this.currentClub?.timezone || this.currentClub?.club_timezone, DEFAULT_TIME_ZONE);
    },
    initLoading() {
      return this.$store.getters['booking/initLoading'];
    },
    availabilityLoading() {
      return this.$store.getters['booking/availabilityLoading'];
    },
    submitting() {
      return this.$store.getters['booking/submitting'];
    },
    pageError() {
      return this.localPageError || this.$store.getters['booking/pageError'];
    },
    submitError() {
      return this.$store.getters['booking/submitError'];
    },
    layout() {
      return this.$store.getters['booking/layout'];
    },
    seats() {
      return this.$store.getters['booking/seats'] || [];
    },
    slotStepMins() {
      return this.$store.getters['booking/slotStepMins'];
    },
    packageTariffs() {
      return buildPackageTariffs(
        this.$store.getters['booking/packageTemplatesRaw'] || [],
        this.$store.getters['booking/packageTariffsRaw'] || []
      );
    },
    visiblePackageTariffs() {
      if (this.bookingMode !== 'package') return this.packageTariffs;

      const dateValue = this.selectedStartDate || this.selectedDate;
      const timeValue = this.selectedStartTime || getTimePart(this.startWheelItems[0]?.value || '');
      const selectedTypes = this.selectedSeatTypes;

      return this.packageTariffs.filter((item) => {
        if (!isTariffVisibleForDateTime(item, dateValue, timeValue)) return false;
        if (!selectedTypes.length) return true;

        const tariffType = this.getTariffSeatType(item);
        return selectedTypes.length === 1 && selectedTypes[0] === tariffType;
      });
    },
    selectedTariff() {
      return this.packageTariffs.find((item) => item.key === String(this.selectedTariffId || '')) || null;
    },
    selectedTariffVisible() {
      if (this.bookingMode !== 'package') return true;
      return this.visiblePackageTariffs.some((item) => item.key === String(this.selectedTariffId || ''));
    },
    activeTariffId() {
      if (this.bookingMode !== 'package') return null;
      const rawId = this.selectedTariff?.id;
      return Number.isFinite(Number(rawId)) ? Number(rawId) : null;
    },
    busySeatIds() {
      return this.$store.getters['booking/busySeatIds'];
    },
    confirmedEndTime() {
      return this.$store.getters['booking/confirmedEndTime'];
    },
    selectedSeatIdSet() {
      return new Set((this.selectedSeatIds || []).map((item) => Number(item)));
    },
    selectedSeats() {
      return this.seats.filter((item) => this.selectedSeatIdSet.has(Number(item.id)));
    },
    selectedSeatTypes() {
      const types = this.selectedSeats
        .map((seat) => this.normalizeSeatType(seat?.seat_type))
        .filter(Boolean);
      return Array.from(new Set(types));
    },
    allowedSeatTypesForPackage() {
      if (this.bookingMode !== 'package' || !this.selectedTariff) return [];
      return [this.getTariffSeatType(this.selectedTariff)];
    },
    selectedSeatsCount() {
      return this.selectedSeats.length;
    },
    selectedSeatsLabel() {
      if (!this.selectedSeats.length) return '—';

      return this.selectedSeats
        .map((item) => {
          const candidates = [
            item?.map_label_short,
            item?.seat_label,
            item?.seat_badge,
            item?.device_name,
            item?.pc_name,
            item?.pc_number,
            item?.seat_number,
            item?.number,
            item?.place_number,
          ];

          for (const value of candidates) {
            const text = String(value || '').trim();
            if (text) return text;
          }

          return String(item?.id || '');
        })
        .join(', ');
    },
    selectedDateLabel() {
      return formatLongDate(this.selectedDate);
    },
    dateContextLabel() {
      const todayValue = this.minBookingDate;
      const tomorrowValue = isoDate(addDays(parseIso(this.minBookingDate), 1));

      if (this.selectedDate === todayValue) return 'Сегодня';
      if (this.selectedDate === tomorrowValue) return 'Завтра';
      return this.selectedDateLabel;
    },
    dateRailOptions() {
      const formatter = new Intl.DateTimeFormat('ru-RU', { weekday: 'short' });
      const base = parseIso(this.minBookingDate);

      return Array.from({ length: 14 }).map((_, index) => {
        const date = addDays(base, index);
        return {
          value: isoDate(date),
          day: pad(date.getDate()),
          weekday: formatter.format(date).replace('.', ''),
        };
      });
    },
    exactLeadValue() {
      const leadDate = getZonedDate(new Date(Date.now() + (MIN_BOOKING_LEAD_MINUTES * 60000)), this.currentClubTimezone);
      leadDate.setSeconds(0, 0);
      return buildDateTimeValue(
        isoDate(leadDate),
        minutesToTime((leadDate.getHours() * 60) + leadDate.getMinutes())
      );
    },
    isExactLeadSelected() {
      return this.startValue === this.exactLeadValue;
    },
    startWheelItems() {
      const items = [];
      const step = this.slotStepMins;
      const todayDate = this.minBookingDate;
      const nowRounded = roundUpToStep(getZonedDate(new Date(Date.now() + (MIN_BOOKING_LEAD_MINUTES * 60000)), this.currentClubTimezone), step);
      const currentDayStart = startOfDay(getZonedDate(new Date(), this.currentClubTimezone));
      const stepLastMinute = (24 * 60) - step;
      const exactLeadValue = this.exactLeadValue;
      const exactLeadDate = getDatePart(exactLeadValue);
      const exactLeadTime = getTimePart(exactLeadValue);
      const exactLeadItems = [];

      this.dateRailOptions.forEach((day) => {
        const startMinuteToday = Math.floor((nowRounded.getTime() - currentDayStart.getTime()) / 60000);
        let startMinute = 0;

        if (day.value === todayDate) {
          startMinute = Math.max(0, startMinuteToday);
        }

        if (day.value === exactLeadDate) {
          exactLeadItems.push({
            value: exactLeadValue,
            label: exactLeadTime,
            caption: relativeDayLabel(exactLeadDate, this.currentClubTimezone),
          });
        }

        const maxMinute = this.bookingMode === 'hourly' ? stepLastMinute : ((24 * 60) - 1);
        for (let minute = startMinute; minute <= maxMinute; minute += step) {
          const timeValue = minutesToTime(minute);
          items.push({
            value: buildDateTimeValue(day.value, timeValue),
            label: timeValue,
            caption: relativeDayLabel(day.value, this.currentClubTimezone),
          });
        }
      });

      const unique = [];
      const seen = new Set();
      [...exactLeadItems, ...items].forEach((item) => {
        if (!item?.value || seen.has(item.value)) return;
        seen.add(item.value);
        unique.push(item);
      });

      return unique;
    },
    endWheelItems() {
      const dateValue = this.selectedStartDate;
      const startTime = this.selectedStartTime;
      if (!dateValue || !startTime) return [];

      if (this.bookingMode === 'package') {
        const pkg = this.selectedTariffVisible ? this.selectedTariff : null;
        if (!pkg) return [];

        const endValue = pkg.ends_at_time
          ? buildDateTimeValueByOffset(
              dateValue,
              startTime,
              (() => {
                const startMinute = timeToMinutes(startTime);
                const fixedEndMinute = timeToMinutes(pkg.ends_at_time);
                return fixedEndMinute > startMinute
                  ? fixedEndMinute - startMinute
                  : ((24 * 60) - startMinute) + fixedEndMinute;
              })()
            )
          : buildDateTimeValueByOffset(dateValue, startTime, Number(pkg.duration_mins || 0));

        return [{
          value: endValue,
          label: getTimePart(endValue),
          caption: relativeDayLabel(getDatePart(endValue), this.currentClubTimezone),
        }];
      }

      const items = [];
      const seen = new Set();

      if (this.isExactLeadSelected) {
        const startDateTime = new Date(`${dateValue}T${String(startTime).slice(0, 5)}:00`);
        const maxDateTime = new Date(startDateTime.getTime() + (24 * 60 * 60000));
        let cursor = roundUpToStep(new Date(startDateTime.getTime() + 60000), this.slotStepMins);

        while (cursor.getTime() <= maxDateTime.getTime()) {
          const value = buildDateTimeValue(
            isoDate(cursor),
            `${pad(cursor.getHours())}:${pad(cursor.getMinutes())}`
          );

          if (!seen.has(value)) {
            seen.add(value);
            items.push({
              value,
              label: getTimePart(value),
              caption: relativeDayLabel(getDatePart(value), this.currentClubTimezone),
            });
          }

          cursor = new Date(cursor.getTime() + (this.slotStepMins * 60000));
        }

        return items;
      }

      for (let diff = this.slotStepMins; diff <= (24 * 60); diff += this.slotStepMins) {
        const value = buildDateTimeValueByOffset(dateValue, startTime, diff);
        if (!value || seen.has(value)) continue;
        seen.add(value);
        items.push({
          value,
          label: getTimePart(value),
          caption: relativeDayLabel(getDatePart(value), this.currentClubTimezone),
        });
      }

      return items;
    },
    selectedStartDate() {
      return getDatePart(this.startValue);
    },
    selectedStartTime() {
      return getTimePart(this.startValue);
    },
    effectiveEndValue() {
      return this.bookingMode === 'package'
        ? (this.endWheelItems[0]?.value || '')
        : this.endValue;
    },
    selectedEndDate() {
      return getDatePart(this.effectiveEndValue) || this.selectedStartDate;
    },
    selectedEndTime() {
      return getTimePart(this.effectiveEndValue);
    },
    selectedStartTimeLabel() {
      return this.formatTimeShort(this.selectedStartTime);
    },
    selectedEndTimeLabel() {
      return this.formatTimeShort(this.selectedEndTime);
    },
    startCardDateLabel() {
      return formatLongDate(this.selectedStartDate);
    },
    endCardDateLabel() {
      return formatLongDate(this.selectedEndDate);
    },
    durationMinutes() {
      return Math.max(0, diffBetweenDateTimeValues(this.startValue, this.effectiveEndValue));
    },
    totalPrice() {
      if (!this.selectedSeats.length) return 0;

      if (this.bookingMode === 'package' && this.selectedTariff) {
        return calculatePackageTotal(this.selectedTariff, this.selectedSeats, this.durationMinutes);
      }

      return this.selectedSeats.reduce((sum, seat) => {
        const rate = Number(seat?.price_per_hour || 0);
        return sum + Math.round((rate / 60) * this.durationMinutes);
      }, 0);
    },
    totalPriceLabel() {
      return this.selectedSeats.length ? this.money(this.totalPrice) : '—';
    },
    confirmedEndTimeLabel() {
      return this.formatTimeShort(this.confirmedEndTime || this.selectedEndTime);
    },
    canGoStep2() {
      return Boolean(
        this.currentClub &&
        this.startValue &&
        this.effectiveEndValue &&
        (this.bookingMode !== 'package' || (this.selectedTariff && this.selectedTariffVisible))
      );
    },
    canSubmit() {
      return Boolean(
        this.user?.hash &&
        this.currentClub?.id &&
        this.startValue &&
        this.effectiveEndValue &&
        this.selectedSeatIds.length &&
        (this.bookingMode !== 'package' || (this.selectedTariff && this.selectedTariffVisible))
      );
    },
    weekdayHeaders() {
      return ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];
    },
    calendarMonthTitle() {
      return formatMonthTitle(this.calendarCursor);
    },
    calendarCanGoPrev() {
      const min = startOfMonth(parseIso(this.minBookingDate));
      return this.calendarCursor.getTime() > min.getTime();
    },
    calendarCanGoNext() {
      const max = startOfMonth(parseIso(this.maxBookingDate));
      return this.calendarCursor.getTime() < max.getTime();
    },
    calendarDays() {
      const monthStart = startOfMonth(this.calendarCursor);
      const firstDay = (monthStart.getDay() + 6) % 7;
      const gridStart = addDays(monthStart, -firstDay);
      const minValue = this.minBookingDate;
      const maxValue = this.maxBookingDate;
      const todayValue = this.minBookingDate;

      return Array.from({ length: 42 }).map((_, index) => {
        const date = addDays(gridStart, index);
        const value = isoDate(date);

        return {
          key: `${value}-${index}`,
          value,
          label: date.getDate(),
          outside: !sameMonth(date, this.calendarCursor),
          disabled: value < minValue || value > maxValue,
          selected: value === this.selectedDate,
          today: value === todayValue,
        };
      });
    },
  },
  watch: {
    bookingMode() {
      this.syncStartSelection();
      this.ensureSelectedTariff();
      this.syncEndSelection();
      this.dropSeatStep();
    },
    selectedTariffId() {
      if (this.bookingMode === 'package') {
        this.syncEndSelection();
        this.dropSeatStep();
      }
    },
    startValue(next) {
      const nextDate = getDatePart(next);
      if (nextDate && nextDate !== this.selectedDate) {
        this.selectedDate = nextDate;
      }

      if (this.bookingMode === 'package') {
        this.ensureSelectedTariff();
      }

      this.syncEndSelection();
      this.dropSeatStep();
    },
    endValue() {
      if (this.bookingMode === 'hourly') {
        this.dropSeatStep();
      }
    },
    selectedDate(next) {
      if (next && next !== this.selectedStartDate) {
        this.jumpStartToDate(next);
      }
    },
    currentClub(next, prev) {
      const nextId = Number(next?.id || 0);
      const prevId = Number(prev?.id || 0);

      if (!nextId || nextId === prevId || this.bootstrapping || nextId === this.bootstrappedClubId) {
        return;
      }

      this.reinitForSelectedClub(nextId);
    },
    step() {
      this.$nextTick(() => {
        this.syncMapViewportHeight();
      });
    },
  },
  async mounted() {
    window.addEventListener('resize', this.handleResize, { passive: true });
    this.handleResize();
    await this.bootstrapPage();
    this.$nextTick(() => {
      this.syncTariffEffects();
      this.syncMapViewportHeight();
    });
  },

  updated() {
    this.syncTariffEffects();
    this.syncMapViewportHeight();
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
    this.cleanupLightningFx();
  },
  methods: {
    normalizeSeatType(value) {
      return normalizeBookingSeatType(value);
    },

    getTariffSeatType(tariff) {
      return normalizeBookingSeatType(tariff?.seat_type);
    },

    isSeatAllowedBySelectedTariff(seat) {
      if (this.bookingMode !== 'package' || !this.selectedTariff) return true;
      const tariffType = this.getTariffSeatType(this.selectedTariff);
      return this.normalizeSeatType(seat?.seat_type) === tariffType;
    },

    packageTariffMeta(tariff) {
      const durationMins = this.getPackageTariffDuration(tariff);
      const discount = Number(tariff?.discount_percent || 0);
      const description = String(tariff?.description || '').trim();
      const hours = durationMins > 0 ? durationMins / 60 : 0;
      const durationText = hours > 0
        ? `${Number.isInteger(hours) ? hours : hours.toFixed(1).replace('.', ',')} ч`
        : '';
      const priceText = this.getPackageTariffPreviewPrice(tariff);
      const discountText = discount > 0 ? `скидка −${discount}%` : '';
      return [description, durationText, priceText, discountText].filter(Boolean).join(' · ');
    },

    getPackageTariffDuration(tariff) {
      if (this.bookingMode === 'package' && this.selectedTariff?.key === tariff?.key && this.durationMinutes > 0) {
        return this.durationMinutes;
      }

      return getPackageDurationMins(tariff, 0);
    },

    getPackageTariffPreviewPrice(tariff) {
      if (!this.selectedSeats.length) {
        return '';
      }

      const durationMins = this.getPackageTariffDuration(tariff);

      if (this.selectedSeats.length === 1) {
        const price = calculatePackagePriceForSeat(tariff, this.selectedSeats[0], durationMins);
        return price > 0 ? this.money(price) : '';
      }

      const total = calculatePackageTotal(tariff, this.selectedSeats, durationMins);
      return total > 0 ? `итого ${this.money(total)}` : '';
    },

    svgToDataUri(svg) {
      const clean = String(svg || '')
        .trim()
        .replace(/\n+/g, ' ')
        .replace(/\t+/g, ' ')
        .replace(/\s{2,}/g, ' ');

      if (!clean) return '';

      return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(clean)}`;
    },

    normalizeTariffBgSvg(tariff) {
      return String(tariff?.bg_svg || '').trim().toLowerCase();
    },

    getTariffFireVariant(tariff) {
      if (this.bookingMode !== 'package') return '';
      const bgSvg = this.normalizeTariffBgSvg(tariff);
      if (bgSvg === 'night') return 'night';
      if (bgSvg === 'blob') return 'blob';
      if (bgSvg === 'lightning') return 'lightning';
      return '';
    },

    hasTariffFire(tariff) {
      return Boolean(this.getTariffFireVariant(tariff));
    },

    getTariffPillClasses(tariff) {
      const fireVariant = this.getTariffFireVariant(tariff);

      return {
        active: this.selectedTariffId === tariff.key,
        'tariff-pill--with-art': Boolean(tariff.bg_svg) && !fireVariant,
        'tariff-pill--fire': Boolean(fireVariant),
        'tariff-pill--fire-night': fireVariant === 'night',
        'tariff-pill--fire-blob': fireVariant === 'blob',
        'tariff-pill--fire-lightning': fireVariant === 'lightning',
      };
    },

    getTariffPillStyle(tariff) {
      if (this.hasTariffFire(tariff)) {
        return {
          '--tariff-bg-image': 'none',
        };
      }

      const svg = tariff?.bg_svg || '';
      if (!svg) {
        return {
          '--tariff-bg-image': 'none',
        };
      }

      return {
        '--tariff-bg-image': `url("${this.svgToDataUri(svg)}")`,
      };
    },

    rand(min, max) {
      return Math.random() * (max - min) + min;
    },

    syncTariffEffects() {
      this.syncTariffFire();
      this.syncTariffLightning();
    },

    syncTariffLightning() {
      if (!this._lightningFx) {
        this._lightningFx = new Map();
      }

      const canvases = Array.from(this.$refs.tariffsSlider?.querySelectorAll?.('[data-lightning-root="1"]') || []);
      const active = new Set(canvases);

      if (this.bookingMode === 'package') {
        canvases.forEach((canvas) => {
          if (!this._lightningFx.has(canvas)) {
            this._lightningFx.set(canvas, this.createLightningFx(canvas));
          }
        });
      }

      Array.from(this._lightningFx.entries()).forEach(([canvas, cleanup]) => {
        if (this.bookingMode !== 'package' || !active.has(canvas)) {
          try {
            cleanup?.();
          } catch (error) {
            // noop
          }
          this._lightningFx.delete(canvas);
        }
      });
    },

    cleanupLightningFx() {
      Array.from(this._lightningFx?.values?.() || []).forEach((cleanup) => {
        try {
          cleanup?.();
        } catch (error) {
          // noop
        }
      });

      if (this._lightningFx) {
        this._lightningFx.clear();
      }
    },

    createLightningFx(canvas) {
      const ctx = canvas.getContext('2d');
      if (!ctx) return () => {};

      const state = {
        dpr: Math.min(window.devicePixelRatio || 1, 2),
        width: 1,
        height: 1,
        running: true,
        rafId: 0,
        nextAt: performance.now() + this.rand(120, 420),
        bolts: [],
        flash: 0,
      };

      const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

      const resize = () => {
        const rect = canvas.getBoundingClientRect();
        state.width = Math.max(1, Math.round(rect.width || 1));
        state.height = Math.max(1, Math.round(rect.height || 1));
        canvas.width = Math.max(1, Math.round(state.width * state.dpr));
        canvas.height = Math.max(1, Math.round(state.height * state.dpr));
        canvas.style.width = `${state.width}px`;
        canvas.style.height = `${state.height}px`;
        ctx.setTransform(state.dpr, 0, 0, state.dpr, 0, 0);
      };

      const buildPath = (startX, startY, direction, maxLength, branchDepth = 0) => {
        const points = [{ x: startX, y: startY }];
        let x = startX;
        let y = startY;
        let dir = direction;
        let travelled = 0;

        while (travelled < maxLength && y < state.height + 18) {
          const step = this.rand(7, 15);
          dir += this.rand(-0.34, 0.34);
          x += Math.cos(dir) * step;
          y += Math.sin(dir) * step;
          x = clamp(x, 10, Math.max(10, state.width - 10));
          points.push({ x, y });
          travelled += step;
        }

        const branches = [];
        if (branchDepth < 1 && points.length > 4) {
          const branchCount = Math.random() > 0.58 ? 2 : 1;
          for (let index = 0; index < branchCount; index += 1) {
            if (Math.random() > 0.72) continue;
            const pivot = points[Math.floor(this.rand(2, Math.max(3, points.length - 2)))];
            if (!pivot) continue;
            const branchDir = direction + this.rand(-0.95, 0.95);
            branches.push(
              buildPath(
                pivot.x,
                pivot.y,
                branchDir,
                maxLength * this.rand(0.24, 0.42),
                branchDepth + 1
              )
            );
          }
        }

        return { points, branches };
      };

      const flatten = (tree, bucket = []) => {
        bucket.push(tree.points);
        (tree.branches || []).forEach((branch) => flatten(branch, bucket));
        return bucket;
      };

      const spawnBolt = () => {
        const originX = this.rand(state.width * 0.16, state.width * 0.84);
        const originY = -6;
        const length = this.rand(state.height * 0.62, state.height * 1.04);
        const baseDirection = (Math.PI / 2) + this.rand(-0.18, 0.18);
        const tree = buildPath(originX, originY, baseDirection, length);

        state.bolts.push({
          paths: flatten(tree),
          age: 0,
          flashDuration: this.rand(70, 120),
          lifeDuration: this.rand(380, 620),
        });
        state.flash = Math.max(state.flash, this.rand(0.12, 0.22));
      };

      const drawPath = (points, alpha, glowAlpha) => {
        if (!points || points.length < 2) return;

        ctx.beginPath();
        ctx.moveTo(points[0].x, points[0].y);
        for (let index = 1; index < points.length; index += 1) {
          ctx.lineTo(points[index].x, points[index].y);
        }

        ctx.strokeStyle = `rgba(125, 195, 255, ${glowAlpha})`;
        ctx.lineWidth = 4.2;
        ctx.shadowBlur = 16;
        ctx.shadowColor = 'rgba(115, 190, 255, 0.95)';
        ctx.stroke();

        ctx.strokeStyle = `rgba(255, 255, 255, ${alpha})`;
        ctx.lineWidth = 1.55;
        ctx.shadowBlur = 8;
        ctx.shadowColor = 'rgba(255, 255, 255, 0.92)';
        ctx.stroke();
      };

      const render = (now) => {
        if (!state.running) return;

        if (now >= state.nextAt) {
          spawnBolt();
          state.nextAt = now + this.rand(900, 1900);
        }

        ctx.clearRect(0, 0, state.width, state.height);
        ctx.globalCompositeOperation = 'source-over';
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';

        if (state.flash > 0.001) {
          ctx.fillStyle = `rgba(167, 215, 255, ${state.flash})`;
          ctx.fillRect(0, 0, state.width, state.height);
          state.flash *= 0.9;
        }

        state.bolts = state.bolts.filter((bolt) => {
          bolt.age += 16.666;

          const alpha = bolt.age <= bolt.flashDuration
            ? 1
            : Math.max(0, 1 - ((bolt.age - bolt.flashDuration) / Math.max(1, bolt.lifeDuration - bolt.flashDuration)));

          if (alpha <= 0.01) {
            return false;
          }

          const glowAlpha = Math.min(0.9, alpha * 0.7);
          bolt.paths.forEach((points) => drawPath(points, alpha, glowAlpha));
          return true;
        });

        state.rafId = window.requestAnimationFrame(render);
      };

      resize();

      let resizeObserver = null;
      if (typeof ResizeObserver !== 'undefined') {
        resizeObserver = new ResizeObserver(() => resize());
        resizeObserver.observe(canvas);
      }

      window.addEventListener('resize', resize, { passive: true });
      state.rafId = window.requestAnimationFrame(render);

      return () => {
        state.running = false;
        if (state.rafId) {
          window.cancelAnimationFrame(state.rafId);
        }
        window.removeEventListener('resize', resize);
        resizeObserver?.disconnect?.();
        ctx.clearRect(0, 0, state.width, state.height);
      };
    },

    syncTariffFire() {
      if (this.bookingMode !== 'package') return;

      const roots = this.$refs.tariffsSlider?.querySelectorAll?.('[data-fire-root="1"]') || [];
      roots.forEach((fire) => {
        const variant = String(fire.dataset.fireVariant || '').toLowerCase();
        if (!variant) return;
        if (fire.dataset.ready === '1') return;
        fire.dataset.ready = '1';

        const config = variant === 'night'
          ? {
              width: 300,
              burnCount: 40,
              heatCount: 40,
              burnSizeMin: 18,
              burnSizeMax: 44,
              burnHeightMin: 10,
              burnHeightMax: 30,
              burnXMin: -20,
              burnXMaxOffset: 20,
              burnDurMin: 1100,
              burnDurMax: 3000,
              burnDelayMin: -3000,
              burnDelayMax: 0,
              heatSizeMin: 10,
              heatSizeMax: 28,
              heatHeightMin: 4,
              heatHeightMax: 10,
              heatXMin: -20,
              heatXMaxOffset: 20,
              heatDurMin: 1000,
              heatDurMax: 2400,
              heatDelayMin: -3000,
              heatDelayMax: 0,
            }
          : {
              width: 260,
              burnCount: 34,
              heatCount: 22,
              burnSizeMin: 18,
              burnSizeMax: 42,
              burnHeightMin: 10,
              burnHeightMax: 28,
              burnXMin: -14,
              burnXMaxOffset: 26,
              burnDurMin: 1200,
              burnDurMax: 2800,
              burnDelayMin: -2800,
              burnDelayMax: 0,
              heatSizeMin: 10,
              heatSizeMax: 24,
              heatHeightMin: 5,
              heatHeightMax: 10,
              heatXMin: -12,
              heatXMaxOffset: 20,
              heatDurMin: 950,
              heatDurMax: 2200,
              heatDelayMin: -2200,
              heatDelayMax: 0,
            };

        const width = fire.clientWidth || config.width;

        for (let i = 0; i < config.burnCount; i += 1) {
          const burn = document.createElement('span');
          burn.className = `tariff-burn tariff-burn--${variant}`;
          burn.style.setProperty('--size', `${this.rand(config.burnSizeMin, config.burnSizeMax)}px`);
          burn.style.setProperty('--h', `${this.rand(config.burnHeightMin, config.burnHeightMax)}px`);
          burn.style.setProperty('--x', `${this.rand(config.burnXMin, Math.max(width - config.burnXMaxOffset, 20))}px`);
          burn.style.setProperty('--dur', `${this.rand(config.burnDurMin, config.burnDurMax)}ms`);
          burn.style.setProperty('--delay', `${this.rand(config.burnDelayMin, config.burnDelayMax)}ms`);
          fire.appendChild(burn);
        }

        for (let i = 0; i < config.heatCount; i += 1) {
          const heat = document.createElement('span');
          heat.className = `tariff-burn tariff-burn--heat tariff-burn--${variant}`;
          heat.style.setProperty('--size', `${this.rand(config.heatSizeMin, config.heatSizeMax)}px`);
          heat.style.setProperty('--h', `${this.rand(config.heatHeightMin, config.heatHeightMax)}px`);
          heat.style.setProperty('--heat-h', `${this.rand(4, 10)}px`);
          heat.style.setProperty('--x', `${this.rand(config.heatXMin, Math.max(width - config.heatXMaxOffset, 16))}px`);
          heat.style.setProperty('--dur', `${this.rand(config.heatDurMin, config.heatDurMax)}ms`);
          heat.style.setProperty('--delay', `${this.rand(config.heatDelayMin, config.heatDelayMax)}ms`);
          fire.appendChild(heat);
        }
      });
    },

    changeMode(mode) {
      this.bookingMode = mode;
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
      this.syncMapViewportHeight();
    },
    getOuterHeight(el) {
      if (!el) return 0;

      const style = window.getComputedStyle(el);
      const marginTop = parseFloat(style.marginTop || '0') || 0;
      const marginBottom = parseFloat(style.marginBottom || '0') || 0;

      return el.offsetHeight + marginTop + marginBottom;
    },
    syncMapViewportHeight() {
      if (typeof window === 'undefined') return;

      if (this.step !== 2 || this.windowWidth > 760) {
        this.mapViewportMinHeight = 0;
        return;
      }

      this.$nextTick(() => {
        window.requestAnimationFrame(() => {
          const mapWrap = this.$refs.mapWrap;
          if (!mapWrap) return;

          const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
          const mobileNav = document.querySelector('.mobile-nav');

          const mapTop = mapWrap.getBoundingClientRect().top;
          const bottomLimit = mobileNav
            ? (mobileNav.getBoundingClientRect().top - 12)
            : (viewportHeight - 12);

          const belowBlocks = [
            this.$refs.rangeCardMap,
            this.$refs.selectionInline,
            this.$refs.actionsSingle,
          ].filter(Boolean);

          const belowHeight = belowBlocks.reduce((sum, el) => sum + this.getOuterHeight(el), 0);
          const freeHeight = Math.floor(bottomLimit - mapTop - belowHeight - 12);

          this.mapViewportMinHeight = Math.max(260, freeHeight);
        });
      });
    },
    async bootstrapPage() {
      this.localPageError = '';
      this.$store.dispatch('booking/resetState');
      this.bootstrapping = true;

      try {
        if (!this.clubs.length) {
          await this.$store.dispatch('clubs/fetchClubs');
        }

        let club = this.currentClub;

        if (!club && this.clubs.length === 1 && this.user?.hash) {
          await this.$store.dispatch('clubs/selectClub', this.clubs[0].id);
          club = this.$store.getters['clubs/currentClub'];
        }

        if (!club) {
          this.bootstrappedClubId = 0;
          this.localPageError = 'Сначала выберите клуб';
          this.$router.push('/clubs')
          return;
        }

        await this.$store.dispatch('booking/initBooking', Number(club.id));
        this.bootstrappedClubId = Number(club.id);
        this.syncDateBounds();
        this.syncStartSelection();
        this.ensureSelectedTariff();
        this.syncEndSelection();
      } catch (error) {
        this.bootstrappedClubId = 0;
        this.localPageError = 'Не удалось открыть экран брони';
      } finally {
        this.bootstrapping = false;
      }
    },
    async reinitForSelectedClub(clubId) {
      const nextClubId = Number(clubId || 0);
      if (!nextClubId) return;

      this.localPageError = '';
      this.step = 1;
      this.selectedSeatIds = [];
      this.$store.dispatch('booking/resetState');

      try {
        this.bootstrapping = true;
        await this.$store.dispatch('booking/initBooking', nextClubId);
        this.bootstrappedClubId = nextClubId;
        this.syncDateBounds();
        this.syncStartSelection();
        this.ensureSelectedTariff();
        this.syncEndSelection();
        this.$nextTick(() => {
          this.syncMapViewportHeight();
        });
      } catch (error) {
        this.bootstrappedClubId = 0;
        this.localPageError = 'Не удалось обновить клуб для бронирования';
      } finally {
        this.bootstrapping = false;
      }
    },
    syncDateBounds() {
      const today = startOfDay(getZonedDate(new Date(), this.currentClubTimezone));
      const maxDate = addDays(today, 13);

      this.minBookingDate = isoDate(today);
      this.maxBookingDate = isoDate(maxDate);

      if (!this.selectedDate || this.selectedDate < this.minBookingDate || this.selectedDate > this.maxBookingDate) {
        this.selectedDate = this.minBookingDate;
      }

      const cursorMonth = startOfMonth(parseIso(this.selectedDate) || today);
      this.calendarCursor = cursorMonth;
    },
    ensureSelectedTariff() {
      if (this.bookingMode !== 'package') {
        this.selectedTariffId = null;
        return;
      }

      if (!this.packageTariffs.length || !this.visiblePackageTariffs.length) {
        this.selectedTariffId = null;
        return;
      }

      const existsInVisible = this.visiblePackageTariffs.some((item) => item.key === String(this.selectedTariffId || ''));
      if (!existsInVisible) {
        this.selectedTariffId = this.visiblePackageTariffs[0].key;
      }
    },
    syncStartSelection() {
      const items = this.startWheelItems;
      if (!items.length) {
        this.startValue = '';
        return;
      }

      const currentExists = items.some((item) => item.value === this.startValue);
      if (currentExists) return;

      const byDate = items.find((item) => getDatePart(item.value) === this.selectedDate);
      this.startValue = byDate?.value || items[0].value;
    },
    syncEndSelection() {
      const items = this.endWheelItems;
      if (!items.length) {
        this.endValue = '';
        return;
      }

      if (this.bookingMode === 'package') {
        this.endValue = items[0].value;
        return;
      }

      const exists = items.some((item) => item.value === this.endValue);
      if (!exists) {
        this.endValue = items[0].value;
      }
    },
    jumpStartToDate(dateValue) {
      const items = this.startWheelItems.filter((item) => getDatePart(item.value) === dateValue);
      if (!items.length) return;

      const exactNoon = items.find((item) => getTimePart(item.value) === '12:00');
      if (exactNoon) {
        this.startValue = exactNoon.value;
        return;
      }

      const noonMinutes = 12 * 60;
      const firstAfterNoon = items.find((item) => timeToMinutes(getTimePart(item.value)) >= noonMinutes);
      this.startValue = firstAfterNoon?.value || items[0].value;
    },
    selectDate(value) {
      this.selectedDate = value;
    },
    openCalendar() {
      this.calendarCursor = startOfMonth(parseIso(this.selectedDate) || parseIso(this.minBookingDate));
      this.calendarOpen = true;
    },
    closeCalendar() {
      this.calendarOpen = false;
    },
    goPrevMonth() {
      if (!this.calendarCanGoPrev) return;
      this.calendarCursor = addMonths(this.calendarCursor, -1);
    },
    goNextMonth() {
      if (!this.calendarCanGoNext) return;
      this.calendarCursor = addMonths(this.calendarCursor, 1);
    },
    selectCalendarDay(value) {
      this.selectedDate = value;
      this.calendarOpen = false;
    },
    selectTariff(id) {
      const exists = this.visiblePackageTariffs.some((item) => item.key === String(id));
      if (exists) {
        this.selectedTariffId = String(id);
      }
    },
    selectSeat(seat) {
      if (!this.isSeatAllowedBySelectedTariff(seat)) {
        this.$store.commit('booking/SET_SUBMIT_ERROR', 'Выбранный пакет не подходит для этого типа места');
        return;
      }

      const seatId = Number(seat.id);
      const exists = this.selectedSeatIds.some((item) => Number(item) === seatId);

      this.selectedSeatIds = exists
        ? this.selectedSeatIds.filter((item) => Number(item) !== seatId)
        : [...this.selectedSeatIds, seatId];

      this.ensureSelectedTariff();
      this.$store.dispatch('booking/clearSubmitError');
    },
    dropSeatStep() {
      this.selectedSeatIds = [];
      this.$store.dispatch('booking/resetAvailability');

      if (this.step === 2) {
        this.step = 1;
      }
    },
    async goStep2() {
      if (!this.canGoStep2) return;

      const result = await this.$store.dispatch('booking/checkAvailability', {
        club_id: Number(this.currentClub.id),
        booking_date: this.selectedStartDate,
        start_time: this.selectedStartTime,
        end_time: this.selectedEndTime,
        pricing_mode: this.bookingMode === 'package' ? 'package' : 'minute',
        package_code: this.bookingMode === 'package' ? (this.selectedTariff?.code || null) : null,
        tariff_id: this.bookingMode === 'package' && this.activeTariffId ? Number(this.activeTariffId) : null,
      });

      if (result?.ok) {
        this.step = 2;
      }
    },
    async submitBooking() {
      if (!this.canSubmit) return;

      const createdOrders = [];

      for (const seatId of this.selectedSeatIds) {
        const result = await this.$store.dispatch('booking/createBooking', {
          club_id: Number(this.currentClub.id),
          seat_id: Number(seatId),
          booking_date: this.selectedStartDate,
          start_time: this.selectedStartTime,
          end_time: this.selectedEndTime,
          pricing_mode: this.bookingMode === 'package' ? 'package' : 'minute',
          package_code: this.bookingMode === 'package' ? (this.selectedTariff?.code || null) : null,
          tariff_id: this.bookingMode === 'package' && this.activeTariffId ? Number(this.activeTariffId) : null,
          comment: '',
          source: 'app',
        });

        if (!result?.ok) {
          if (createdOrders.length) {
            this.$router.push('/requests');
          }
          return;
        }

        createdOrders.push(result?.order || null);
      }

      if (createdOrders.length === 1) {
        const orderNumber = createdOrders[0]?.order_number || '';
        if (orderNumber) {
          this.$router.push(`/requests/${orderNumber}`);
          return;
        }
      }

      this.$router.push('/requests');
    },
    goBack() {
      if (this.step === 2) {
        this.step = 1;
        return;
      }

      if (window.history.length > 1) {
        this.$router.back();
        return;
      }

      this.$router.push('/');
    },
    minsLabel(mins) {
      const value = Number(mins || 0);
      if (!value) return '—';

      const hours = Math.floor(value / 60);
      const minutes = value % 60;

      if (hours && minutes) return `${hours} ч ${minutes} мин`;
      if (hours) return `${hours} ч ${pad(minutes)} мин`;
      return `${minutes} мин`;
    },
    money(value) {
      return `${Number(value || 0).toLocaleString('ru-RU')} ₽`;
    },
    formatTimeShort(value) {
      if (!value) return '—';
      return String(value).slice(0, 5);
    },
  },
};
</script>

<style scoped src="./BookView.css"></style>